import { render, staticRenderFns } from "./IntroClassifyControls.vue?vue&type=template&id=3ef6667c&scoped=true&"
import script from "./IntroClassifyControls.vue?vue&type=script&lang=js&"
export * from "./IntroClassifyControls.vue?vue&type=script&lang=js&"
import style0 from "./IntroClassifyControls.vue?vue&type=style&index=0&id=3ef6667c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef6667c",
  null
  
)

export default component.exports